<template>
    <component ref="blockData" :is="component" :data="data" :preview="preview" v-if="component" />
</template>

<script>
export default {
    name: 'dynamic-link',
    props: {
        'data': {
            type: Object,
            required: true
        }, 'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            component: null,
            // type supported: layout, config
        }
    },
    computed: {
        loader() {
            console.log("STAMPA DEBUG COSE", this.data, this.data.block.template)
            if (!this.data.block || !this.data.block.template) {
                return null
            } 
            return () => import(`../../instrument_sections/${this.data.block.template}`)
        },
    },
    methods: {
        loadingMethod(){
            this.loader()
            .then(() => {
                console.log("loading...")
                this.component = () => this.loader()
            })
            .catch((error) => {
                console.log("Exception", error);
                this.component = () => import('../../blocks/layout/defaultError')
            })
        },
        getData() {
            return this.$refs.blockData.getData()
        }
    },
    mounted() {
        this.loadingMethod()
    },
    watch: {
        'data.block':{
            deep:true,
            handler(){
                this.loadingMethod()
            }
        }
    },
}
</script>